// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4705":"fde28e87","4715":"fde28e87","6169":"fde28e87","8822":"75774e2a"}[chunkId] + ".chunk.css";
};